export type OutreachStage =
  | 'New Lead' |'Identified' |'Researching' |'LinkedIn Requested' |'LinkedIn Connected' |'Intro Sent' |'TL Shared' |'Meeting Requested' |'Meeting Confirmed' |'Met at Event' |'Follow-up Sent' |'Opportunity Created' |'Closed / No Response' |'Not Relevant';

export type LinkedInStatus =
  | 'Not Attempted' |'Connection Planned' |'Request Sent' |'Connected' |'Message Sent' |'Replied' |'No Response' |'Follow-up Needed';

export type MeetingStatus =
  | 'None' |'Requested' |'Tentative' |'Confirmed' |'Completed' |'Cancelled' |'No-show';

export type Priority = 'High' | 'Medium' | 'Low';

export interface Contact {
  id: string;
  firstName: string;
  lastName: string;
  title: string;
  company: string;
  industry: string;
  country: string;
  email: string;
  linkedinUrl: string;
  event: string;
  outreachStage: OutreachStage;
  linkedinStatus: LinkedInStatus;
  meetingStatus: MeetingStatus;
  priority: Priority;
  priorityScore: number;
  lastActivity: string;
  nextActionDate: string;
  tags: string[];
  notes: string;
}

// Backend integration point: replace with API call GET /api/contacts
export const mockContacts: Contact[] = [
  {
    id: 'contact-001',
    firstName: 'Sarah',
    lastName: 'Kowalski',
    title: 'VP of Procurement',
    company: 'Sysco Corp',
    industry: 'Food Distribution',
    country: 'USA',
    email: 'sarah.kowalski@sysco.com',
    linkedinUrl: 'linkedin.com/in/sarahkowalski',
    event: 'NRA Show 2026',
    outreachStage: 'Meeting Confirmed',
    linkedinStatus: 'Connected',
    meetingStatus: 'Confirmed',
    priority: 'High',
    priorityScore: 92,
    lastActivity: '2026-03-20',
    nextActionDate: '2026-03-24',
    tags: ['key-account', 'procurement'],
    notes: 'Very interested in supply chain solutions.',
  },
  {
    id: 'contact-002',
    firstName: 'Raj',
    lastName: 'Patel',
    title: 'Chief Purchasing Officer',
    company: 'US Foods',
    industry: 'Food Distribution',
    country: 'USA',
    email: 'raj.patel@usfoods.com',
    linkedinUrl: 'linkedin.com/in/rajpatel',
    event: 'NRA Show 2026',
    outreachStage: 'Meeting Confirmed',
    linkedinStatus: 'Replied',
    meetingStatus: 'Confirmed',
    priority: 'High',
    priorityScore: 89,
    lastActivity: '2026-03-21',
    nextActionDate: '2026-03-25',
    tags: ['cpo', 'large-account'],
    notes: 'Confirmed 2pm slot on May 17.',
  },
  {
    id: 'contact-003',
    firstName: 'Claire',
    lastName: 'Dubois',
    title: 'Head of Innovation',
    company: 'Nestlé Professional',
    industry: 'Food Manufacturing',
    country: 'Switzerland',
    email: 'claire.dubois@nestle.com',
    linkedinUrl: 'linkedin.com/in/clairedubois',
    event: 'NRA Show 2026',
    outreachStage: 'Intro Sent',
    linkedinStatus: 'Connected',
    meetingStatus: 'Tentative',
    priority: 'High',
    priorityScore: 84,
    lastActivity: '2026-03-18',
    nextActionDate: '2026-03-23',
    tags: ['innovation', 'enterprise'],
    notes: 'Shared the food tech article.',
  },
  {
    id: 'contact-004',
    firstName: 'Marcus',
    lastName: 'Webb',
    title: 'Director of Operations',
    company: 'Gordon Food Service',
    industry: 'Food Distribution',
    country: 'USA',
    email: 'marcus.webb@gfs.com',
    linkedinUrl: 'linkedin.com/in/marcuswebb',
    event: 'NRA Show 2026',
    outreachStage: 'Meeting Requested',
    linkedinStatus: 'Message Sent',
    meetingStatus: 'Requested',
    priority: 'High',
    priorityScore: 81,
    lastActivity: '2026-03-19',
    nextActionDate: '2026-03-22',
    tags: ['operations', 'distribution'],
    notes: 'Awaiting meeting confirmation.',
  },
  {
    id: 'contact-005',
    firstName: 'Priya',
    lastName: 'Mehta',
    title: 'Sustainability Manager',
    company: 'Sodexo',
    industry: 'Food Services',
    country: 'UK',
    email: 'priya.mehta@sodexo.com',
    linkedinUrl: 'linkedin.com/in/priyamehta',
    event: 'NRA Show 2026',
    outreachStage: 'TL Shared',
    linkedinStatus: 'Connected',
    meetingStatus: 'None',
    priority: 'Medium',
    priorityScore: 74,
    lastActivity: '2026-03-17',
    nextActionDate: '2026-03-24',
    tags: ['sustainability', 'mid-market'],
    notes: 'Shared sustainability whitepaper.',
  },
  {
    id: 'contact-006',
    firstName: 'Tom',
    lastName: 'Westerfield',
    title: 'President',
    company: 'Westerfield Hospitality',
    industry: 'Hospitality',
    country: 'USA',
    email: 'tom@westerfieldhosp.com',
    linkedinUrl: 'linkedin.com/in/tomwesterfield',
    event: 'NRA Show 2026',
    outreachStage: 'LinkedIn Connected',
    linkedinStatus: 'Connected',
    meetingStatus: 'None',
    priority: 'High',
    priorityScore: 78,
    lastActivity: '2026-03-16',
    nextActionDate: '2026-03-22',
    tags: ['hospitality', 'c-suite'],
    notes: 'Just connected. Send intro message.',
  },
  {
    id: 'contact-007',
    firstName: 'Elena',
    lastName: 'Kovács',
    title: 'Category Manager',
    company: 'Compass Group',
    industry: 'Contract Catering',
    country: 'Hungary',
    email: 'elena.kovacs@compass-group.com',
    linkedinUrl: 'linkedin.com/in/elenakovacs',
    event: 'NRA Show 2026',
    outreachStage: 'Intro Sent',
    linkedinStatus: 'Message Sent',
    meetingStatus: 'None',
    priority: 'Medium',
    priorityScore: 67,
    lastActivity: '2026-03-15',
    nextActionDate: '2026-03-23',
    tags: ['catering', 'category'],
    notes: 'Intro sent. No reply yet.',
  },
  {
    id: 'contact-008',
    firstName: 'David',
    lastName: 'Okafor',
    title: 'CEO',
    company: 'Fresh Direct Logistics',
    industry: 'Logistics',
    country: 'USA',
    email: 'david.okafor@freshdirect.com',
    linkedinUrl: 'linkedin.com/in/davidokafor',
    event: 'NRA Show 2026',
    outreachStage: 'LinkedIn Requested',
    linkedinStatus: 'Request Sent',
    meetingStatus: 'None',
    priority: 'Medium',
    priorityScore: 61,
    lastActivity: '2026-03-14',
    nextActionDate: '2026-03-21',
    tags: ['logistics', 'ceo'],
    notes: 'LinkedIn request pending.',
  },
  {
    id: 'contact-009',
    firstName: 'Maria',
    lastName: 'Santos',
    title: 'Procurement Director',
    company: 'Aramark',
    industry: 'Food Services',
    country: 'USA',
    email: 'maria.santos@aramark.com',
    linkedinUrl: 'linkedin.com/in/mariasantos',
    event: 'NRA Show 2026',
    outreachStage: 'Researching',
    linkedinStatus: 'Connection Planned',
    meetingStatus: 'None',
    priority: 'High',
    priorityScore: 76,
    lastActivity: '2026-03-13',
    nextActionDate: '2026-03-22',
    tags: ['procurement', 'large-account'],
    notes: 'Profile reviewed. Send LinkedIn.',
  },
  {
    id: 'contact-010',
    firstName: 'James',
    lastName: 'Nakamura',
    title: 'VP Sales',
    company: 'Tyson Foods',
    industry: 'Food Manufacturing',
    country: 'USA',
    email: 'j.nakamura@tyson.com',
    linkedinUrl: 'linkedin.com/in/jamesnakamura',
    event: 'NRA Show 2026',
    outreachStage: 'Follow-up Sent',
    linkedinStatus: 'Replied',
    meetingStatus: 'Completed',
    priority: 'High',
    priorityScore: 88,
    lastActivity: '2026-03-22',
    nextActionDate: '2026-03-26',
    tags: ['met-at-event', 'follow-up'],
    notes: 'Had great meeting. Follow-up sent.',
  },
  {
    id: 'contact-011',
    firstName: 'Fatima',
    lastName: 'Al-Rashidi',
    title: 'Supply Chain Director',
    company: 'Emirates Flight Catering',
    industry: 'Airline Catering',
    country: 'UAE',
    email: 'f.alrashidi@ekfc.ae',
    linkedinUrl: 'linkedin.com/in/fatimaalrashidi',
    event: 'FOODEX Japan 2026',
    outreachStage: 'Identified',
    linkedinStatus: 'Not Attempted',
    meetingStatus: 'None',
    priority: 'Medium',
    priorityScore: 58,
    lastActivity: '2026-03-10',
    nextActionDate: '2026-04-01',
    tags: ['airline', 'middle-east'],
    notes: 'Identified for FOODEX.',
  },
  {
    id: 'contact-012',
    firstName: 'Henrik',
    lastName: 'Lindström',
    title: 'Innovation Director',
    company: 'ICA Gruppen',
    industry: 'Retail Grocery',
    country: 'Sweden',
    email: 'henrik.lindstrom@ica.se',
    linkedinUrl: 'linkedin.com/in/henriklindstrom',
    event: 'FOODEX Japan 2026',
    outreachStage: 'New Lead',
    linkedinStatus: 'Not Attempted',
    meetingStatus: 'None',
    priority: 'Low',
    priorityScore: 42,
    lastActivity: '2026-03-08',
    nextActionDate: '2026-04-05',
    tags: ['retail', 'nordics'],
    notes: 'Imported from conference attendee list.',
  },
];